import React from "react";
import { Spin, Alert, Progress, Button, Typography } from "antd";
import { FONT } from "../../styles/typography";

/**
 * 住客體驗卡裡的滿意度摘要。純呈現，不取資料 —— 資料由 OpsDashboard 取一次後
 * 同時餵給這裡與下方的完整摘要卡，避免兩處各自呼叫端點而出現一邊已載入、
 * 另一邊顯示錯誤的不一致畫面。
 *
 * 四種狀態各有明確畫面，沿用「AI 摘要是加值而非前提」的原則：即使摘要還沒產生，
 * 則數與平均星等仍然有意義，不該一起消失。
 */
export default function SatisfactionSummary({ data, error, onViewMore }) {
  // 摘要卡右上原本那顆「明細」按鈕拿掉後，這顆是全畫面唯一的下鑽入口。摘要端點掛掉
  // 時明細走的是另一個獨立端點、通常還活著 —— 把按鈕跟著錯誤一起收掉，等於摘要壞掉
  // 就連原始回饋都看不到，正好違反「AI 是加值而非前提」。
  const viewButton = (
    <Button size="small" style={{ marginTop: 10 }} onClick={onViewMore}>
      查看客戶意見回饋
    </Button>
  );

  if (error) {
    return (
      <>
        <Alert type="error" showIcon message="讀取住客回饋失敗" style={{ marginTop: 4 }} />
        {viewButton}
      </>
    );
  }

  if (!data) {
    return <Spin size="small" />;
  }

  if (!data.item_count) {
    return (
      <Typography.Text type="secondary">
        本期尚無住客回饋
      </Typography.Text>
    );
  }

  const sentiment = data.summary && data.summary.sentiment;

  return (
    <>
      <div style={{ display: "flex", alignItems: "baseline", gap: 12, flexWrap: "wrap" }}>
        <span>本期 <b>{data.item_count} 則</b></span>
        <span>
          平均 <b>{data.avg_rating == null ? "—" : `${Number(data.avg_rating).toFixed(1)} 星`}</b>
          {/* 帶星等的筆數要講出來 —— 否則「48 則、平均 4.3 星」會讓人以為 48 則都給了星等 */}
          <Typography.Text type="secondary" style={{ fontSize: FONT.caption, marginLeft: 4 }}>
            ({data.rated_count} 則帶星等)
          </Typography.Text>
        </span>
      </div>

      {sentiment && (
        <div style={{ marginTop: 8 }}>
          <Progress
            percent={100}
            showInfo={false}
            size="small"
            success={{ percent: sentiment.positive }}
          />
          <Typography.Text type="secondary" style={{ fontSize: FONT.caption }}>
            正面 {sentiment.positive}%・中性 {sentiment.neutral}%・負面 {sentiment.negative}%
          </Typography.Text>
        </div>
      )}

      {/* 文案不再隨有無摘要切換成「查看完整摘要」—— 完整摘要就在同一頁的正下方，
          為了捲一段距離而佔一顆按鈕並不划算。這顆固定通往回饋明細。 */}
      {viewButton}
    </>
  );
}
